import { MaskLines } from "./Motion";
import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, lines, intro, image, testid }) {
  return (
    <section data-testid={testid} className="relative overflow-hidden bg-navy text-white grain">
      <div className="absolute inset-0 grid-lines" />
      {image && (
        <motion.img
          src={image}
          alt=""
          aria-hidden="true"
          initial={{ scale: 1.15, opacity: 0 }}
          animate={{ scale: 1, opacity: 0.35 }}
          transition={{ duration: 1.8, ease: [0.16, 1, 0.3, 1] }}
          className="absolute inset-0 h-full w-full object-cover"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/30" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8 pt-36 pb-16 md:pt-44 md:pb-24">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="eyebrow text-brand flex items-center gap-3">
          <span className="h-px w-10 bg-brand" /> {eyebrow}
        </motion.p>
        <h1 className="mt-6 font-display font-extrabold uppercase leading-[0.9] tracking-tight text-5xl sm:text-6xl lg:text-8xl">
          <MaskLines lines={lines} />
        </h1>
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="mt-8 max-w-2xl text-base md:text-lg text-slate-300 leading-relaxed"
          >
            {intro}
          </motion.p>
        )}
      </div>
    </section>
  );
}
